import classNames from 'classnames';
import useUnitProvider from '/@/core/context/unit';
import settings from '/@/core/settings';
import { convertAreaFromM2 } from '/@/hooks/geometry/area';
import { _ } from '/@/locale';
import Input from '/@/v3/components/forms/input';
import styles from './styles.module.css';

interface Zone {
    type: string;
    name: object;
}

interface Node {
    zones: Zone[];
}

interface Field {
    name: string;
    location?: string;
    altitude?: number;
    mapValues?: any[];
    selected?: boolean;
    node?: Node;
}

interface Form {
    name: string;
}

interface NewFieldInfoProps {
    field: Field;
    view?: string;
    edit?: boolean;
    handleChange: (params: { value: any; name: string }) => void;
    form: Form;
    disabled?: boolean;
}

const NewFieldInfo: React.FC<NewFieldInfoProps> = (props) => {
    const { field, form, handleChange, disabled } = props;
    const units = useUnitProvider();

    return (
        <div className={styles.root}>
            <div className={classNames(styles.data, styles.field)}>
                <div className={styles.label}>{_('Nombre del lote')}</div>
                <div className={styles.editContainer}>
                    <Input
                        value={form.name}
                        name='name'
                        onChange={(value, name) => handleChange({ value, name })}
                        size='md'
                        color={settings.app.theme}
                        extraClass={styles.input}
                        disabled={disabled}
                        editIcon
                        error={
                            form.name.length > 50 || !form.name
                                ? _('El nombre del lote debe tener entre 1 y 50 caracteres')
                                : false
                        }
                    />
                </div>
            </div>
            {field.location && (
                <div className={styles.data}>
                    <div>
                        <div className={styles.label}>{_('Ubicación')}</div>
                        <div className={styles.fieldData}>{field.location}</div>
                    </div>
                </div>
            )}
            {field?.area !== null && field?.area !== undefined && (
                <div className={styles.data}>
                    <div>
                        <div className={styles.label}>{_('Área')}</div>
                        <div className={styles.fieldData}>{convertAreaFromM2(field.area, units).toString()}</div>
                    </div>
                </div>
            )}
            {field?.altitude !== null && field?.altitude !== undefined && (
                <div className={styles.data}>
                    <div>
                        <div className={styles.label}>{_('Altitud')}</div>
                        <div className={styles.fieldData}>{Math.round(field.altitude)} m</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewFieldInfo;
